import styled from "styled-components";
import { deviceSpec } from "breakpoints";
import { Chip, FormControl, Tabs, Paper, Select, Typography, Autocomplete, Modal, Button, TableRow } from "@mui/material";
import { Tooltip } from "recharts";


// shared
export const AdminPanelContainer = styled('div')`
    padding: 2rem;
    display: flex;
    justify-content: center;
`

export const AdminTitle = styled('div')`
    font-size: ${({theme}) => theme.font.xl};
    display: flex;
    border-bottom: ${({theme}) => theme.borders.headerBorder};
    padding: .75rem 1.25rem;
    position: relative;
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
    justify-content: space-between;
`;


// adminUsers.tsx
export const AdminUserUpdateContainer = styled(Paper)`
    border-bottom: ${({theme}) => theme.borders.headerBorder};
`;

export const AdminUserDetailsContainer = styled('div')``;

export const AdminUserDetails = styled('div')`
    display: flex;
    flex-direction: row;
    margin-bottom: 0.25rem;
`;

export const AdminUserGroups = styled('div')`
    display: flex;
    flex-direction: column;
    
    > strong {
        margin-bottom: 0.75rem;
    }

    .MuiFormControl-root {
        label {
            position: absolute;
            top: calc((100% - 1.25rem)/2);
            bottom: 0;
            left: 1rem;
            transform: none;
        }
    }

    textarea, .custom-input, select, textarea:active, .custom-input:active, select:active {
        background-color: transparent !important;
        border: 1px solid ${({theme}) => theme.colors.buttonBorder};
    }
`;

export const AdminAutocompleteForm = styled(FormControl)`
    display: flex;
    width: 100%;
    
    .MuiAutocomplete-root {
        .MuiOutlinedInput-root {
            padding: 8px 14px;
        }

        .MuiAutocomplete-endAdornment {
            top: calc(50% - 14px);
        }

        .MuiAutocomplete-listbox {
            max-height: 300px;
            overflow-y: auto;
            scrollbar-width: thin;
            
            &::-webkit-scrollbar {
                width: 8px;
            }
            
            &::-webkit-scrollbar-track {
                background: rgba(0, 0, 0, 0.1);
                border-radius: 4px;
            }
            
            &::-webkit-scrollbar-thumb {
                background: rgba(128, 128, 128, 0.5);
                border-radius: 4px;
            }
        }

        .MuiAutocomplete-option {
            padding: 8px 16px;
            min-height: 48px;
            display: flex;
            align-items: center;

            &:hover {
                background-color: rgba(255, 255, 255, 0.08);
            }

            &[aria-selected="true"] {
                background-color: rgba(255, 255, 255, 0.12);
            }
        }
    }
`;

export const AdminUserGroupsAutoComplete = styled(Autocomplete)`
    .MuiChip-root {
        margin: 0.25rem;
        border-color: #90caf9;
    }

    .MuiChip-root:hover {
        background-color: ${({theme}) => theme.colors.mediumGrey };
    }
`;

export const AdminUserGroupsChip = styled(Chip)`
    padding: 0.5rem;
    margin: 4px;
    border-radius: 16px;
    font-size: 0.875rem;
    height: 32px;
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    
    .MuiChip-label {
        padding: 0 8px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    .MuiChip-deleteIcon {
        margin: 0 4px 0 -4px;
    }
`;

// adminInvite.tsx
export const SimpleTableContainer = styled(Paper)<{ columns: number }>`
    // This uses MUI Table, TableBody, TableHeader, TableRow
    background-color: ${({ theme }) => theme.colors.tableBackground};
    padding: 2rem;
    border-radius: 5px;

    // Stylings for the switch
    .Mui-checked {
        .MuiSwitch-thumb {
            color:  ${({ theme }) => theme.colors.medium};
        }
    }

    .MuiSwitch-track {
        background-color:  #af61ec !important;
    }

    .unexpanded-row-container {
        cursor: pointer;
    }

    // Place a border under every logical separation
    .outer-row-container, .unexpanded-row-container, .outer-header-container {
        border-bottom: 1px solid rgb(81, 81, 81);
    }
    
    // Highlight the row on hover
    .unexpanded-row-container:hover {
        background: rgba(255, 255, 255, 0.08);
    }

    // Format for buttons
    // <div className="row-buttons"> <IconButton> BTN HERE </IconButton> </div>
    .row-buttons {
        display: flex;
        justify-content: end;
        align-items: start;
        margin: 3px 0;
        width: 35px;
    }
    
    // Add to IconButton class
    .icon-button {
        padding: 0.25rem;
        margin: 0;
        border-radius: 5px;
        height: min-content;
    }

    // Div wrap the rows, then div w .row-items, then div w .row-item or div w .header-item
    .unexpanded-row-container, .outer-header-container {
        display: flex;
        justify-content: space-between;

        .row-items {
            display: grid;
            // Grid of: name: 1/5th, description: 4/5ths, icon: 40px
            grid-template-columns: ${({ columns = 3 }) => `repeat(${columns}, 1fr)`};
            width: 100%;

            .row-item {
                padding: 10px;
                text-align: left;
                margin: 0;
                word-break: normal;
                word-wrap: normal;
                overflow: hidden;
            }

            .header-item {
                font-weight: bold;
                padding: 10px;
                text-align: left;
                margin: 0;
            }
        }
    }
`;

export const AdminItemsRow = styled('div')``;

// adminInvite.tsx
export const AdminItemsContainer = styled('div')`
    padding: 1.25rem 1.25rem 0 1.25rem;
`;

export const AdminInviteDetailsContainer = styled('div')``;

export const AdminInviteDetails = styled('div')`
    display: flex;
    flex-direction: row;
    margin-bottom: 0.25rem;
    align-items: center;

    margin: 0.5rem 0;

    strong {
        margin-right: 0.5rem;
    }

    .MuiCheckbox-root {
        padding: 0;
    }
    
    p {
        width: 100%;
        word-wrap: unset;
        word-break: unset;    
    }
`;

export const AdminItemContainer = styled('div')`
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;

    ol, ul, menu {
        list-style: revert;
        padding: revert;
        margin: 0;
    }
    
    li, p {
        color: ${({theme}) => theme.colors.textColor};
        margin-top: 0;
    }

    :last-child {
        margin-bottom: 0;
    }
    
    > strong {
        margin-bottom: 0.75rem;
    }

    .MuiFormControl-root {
        label {
            position: absolute;
            top: calc((100% - 1.25rem)/2);
            bottom: 0;
            left: 1rem;
            transform: none;
        }
        
        box-shadow: inset 1px 1px 2.2px hsl(0deg 0% 0% / 0.3);
        background-color: rgba(255, 255, 255, 0.1);
    }

    textarea, .custom-input, select, textarea:active, .custom-input:active, select:active {
        background-color: transparent !important;
        border: 1px solid ${({theme}) => theme.colors.buttonBorder};
    }
`;

export const AdminItemContainerForm = styled(FormControl)`
    display: flex;
    width: 100%;
    
    .MuiAutocomplete-root {
        .MuiOutlinedInput-root {
            padding: 8px 14px;
        }

        .MuiAutocomplete-endAdornment {
            top: calc(50% - 14px);
        }

        .MuiAutocomplete-listbox {
            max-height: 300px;
            overflow-y: auto;
            scrollbar-width: thin;
            
            &::-webkit-scrollbar {
                width: 8px;
            }
            
            &::-webkit-scrollbar-track {
                background: rgba(0, 0, 0, 0.1);
                border-radius: 4px;
            }
            
            &::-webkit-scrollbar-thumb {
                background: rgba(128, 128, 128, 0.5);
                border-radius: 4px;
            }
        }

        .MuiAutocomplete-option {
            padding: 8px 16px;
            min-height: 48px;
            display: flex;
            align-items: center;

            &:hover {
                background-color: rgba(255, 255, 255, 0.08);
            }

            &[aria-selected="true"] {
                background-color: rgba(255, 255, 255, 0.12);
            }
        }
    }
`;

export const AdminItemContainerAutoComplete = styled(Autocomplete)`
    .MuiChip-root {
        margin: 0.25rem;
        border-color: #90caf9;
    }

    // .MuiChip-root:hover {
    //     background-color: ${({theme}) => theme.colors.mediumGrey };
    // }
`;

export const AdminItemContainerChip = styled(Chip)`
    padding: 0.5rem;
    margin: 4px;
    border-radius: 16px;
    font-size: 0.875rem;
    height: 32px;
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    
    .MuiChip-label {
        padding: 0 8px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    .MuiChip-deleteIcon {
        margin: 0 4px 0 -4px;
    }
`;


// adminGroups.tsx
export const AdminGroupsForm = styled(FormControl)`
    display: flex;
    width: 100%;
    
    // .MuiButtonBase-root:hover {
    //     background-color: ${({theme}) => theme.colors.mediumGrey };
    //     cursor: pointer;
    // }
`;

export const AdminFormGroup = styled(FormControl)`
    display: flex !important;
    flex-direction: column !important;
    margin-bottom: 1rem !important;
`;

export const AdminModal = styled(Modal)`
    .MuiPaper-root {
        border-radius: 1rem;
        border: none;
        box-shadow: 1.5px 3.0px 3.0px hsl(0deg 0% 0% / 0.45);
    }
`;

export const AdminModalInnerContainer = styled(Paper)`
    width: max-content;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    border: 2px solid #000;
    
    @media (min-width: 576px) {
        .modal-dialog {
            max-width: 500px;
            margin-right: auto;
            margin-left: auto;
        }
    }

    .MuiAutocomplete-root {
        input {
            border: none;
        }
    }

    textarea, input, select, textarea:active, input:active, select:active {
        background-color: transparent !important;
        border: 1px solid ${({theme}) => theme.colors.buttonBorder};
        padding: .375rem .75rem;
    }

    .MuiPaper-root {
        border-radius: 0 0 1rem 1rem;
        display: flex;
        justify-content: end;
    }

    button {
        border-top: ${({theme}) => theme.borders.headerBorder};
        background-color: ${({theme}) => theme.colors.light};
        color: ${({theme}) => theme.colors.white};
    }
`;

export const AdminModalBody = styled('div')`
    padding: 1.25em;
`

export const CreateApiKeyModalContainer = styled(Paper)`
    width: max-content;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    border: 2px solid #000;
    
    @media (min-width: 576px) {
        .modal-dialog {
            max-width: 500px;
            margin-right: auto;
            margin-left: auto;
        }
    }

    .MuiAutocomplete-root {
        width: max-content;
        input {
            border: none;
        }
    }

    textarea, input, select, textarea:active, input:active, select:active {
        background-color: transparent !important;
        border: 1px solid ${({theme}) => theme.colors.buttonBorder};
        padding: .375rem .75rem;
    }

    input {
        padding: 0.75em;
        word-wrap: unset;
        overflow: scroll;
        word-break: unset;
        height: 3rem;
        display: flex;
        align-items: center;
        border: 1px solid ${({theme}) => theme.colors.buttonBorder};
        width: 100%;
    }

    .MuiPaper-root {
        border-radius: 0 0 1rem 1rem;
        display: flex;
        justify-content: end;
    }

`;

export const ApiKeyModalBody = styled('div')`
    display: flex;
    flex-direction: column;
    padding: .75rem 1.25rem;

    button {
        border-radius: 0 4px 4px 0;
        cursor: pointer;
        box-shadow: ${({theme}) => theme.shadows.button};
    }
`;

export const AdminModalButtonContainer = styled('div')`
    display: flex;
    justify-content: end;
    padding: 0 1.25rem 1.25rem;
`;


export const ValidatorText = styled('div')`
    margin-top: 1rem;
    margin-left: 0.25rem;

    p { 
        color: ${({theme}) => theme.colors.warningColor };
    }
`;


// adminPanel.tsx
export const AdminContainer = styled('div')`
    display: flex;
    flex-direction: column;
    //   display: grid;
    //   grid-template-columns: 1fr 3fr;
    //   gap: 10px;

    //   @media (max-width: 1000px) {
    //     grid-template-columns: 1fr;
    //   }

    .oval {
        width: 400px;
        height: 250px;
        color: #111;
        border-radius: 50%;
        text-align: center;
        font-size: 90px;
        float: left;
        shape-outside: ellipse();
        padding: 10px;
    }
    
    span {
        display: inline-block;
    }

    .max-content {
        width: max-content;
    }
`

// adminHome.tsx
export const CustomTabs = styled(Tabs)`
    .MuiTabs-flexContainer {
        overflow-x: scroll;
    }
`

// The options container
export const RagDadOptionsWrapper = styled('div')`
    display: grid;
    grid-template-columns: 2fr 8fr;
    gap: 1em;
    
    .MuiButton-root {
        align-items: start;
        padding: 0.75em;
        border: 2px solid ${({theme}) => theme.colors.lightGreyRgba} !important;
        opacity: 0.8;
    }

    .MuiButton-root:hover {
        background-color: ${({theme}) => theme.colors.lightGrey} !important;
    }

    .MuiInputBase-root {
        height: 34px;
        align-self: center;
        border-color: ${({ theme }) => theme.colors.buttonBorder};
        color: ${({ theme }) => theme.colors.buttonText};
        border-radius: 5px !important;
    }

    .recharts-default-tooltip {
        background-color: ${({ theme }) => theme.colors.buttonBorder} !important;
        box-shadow: ${({theme}) => theme.shadows.button};
        border-radius: 5px !important;
        border: none !important;
    }

    .recharts-tooltip-item-value {
        padding-left: 0.25rem;
    }
`

export const MetricsContainer = styled('div')`
    > div {
        margin-top: 1rem;
    }

    > div:nth-child(1) {
        margin-top: 0;
    }
`

export const RagDadOption = styled(Paper)`
    padding: 1em;
    display: flex;
    flex-direction: column;
    align-items: start;

    box-shadow:
      0 1px 1px hsl(0deg 0% 0% / 0.1),
      0 2px 2px hsl(0deg 0% 0% / 0.1),
      0 4px 4px hsl(0deg 0% 0% / 0.1),
      0 8px 8px hsl(0deg 0% 0% / 0.1),
      0 16px 16px hsl(0deg 0% 0% / 0.1)
    ;

    svg {
        margin-bottom: 0.5em;
        opacity: 0.8;
        position: absolute;
        top: 15%;
        left: 5%;
    }

    p {
        text-align: left;
        word-break: normal;
    }

    :
`

export const OptionData = styled('div')`
`

export const CustomTooltip = styled(Tooltip)`
    background-color: blue !important;
`